// Mock data for Canadian Trademark Registration Website

export const testimonials = [
  {
    id: 1,
    name: "Emily Thompson",
    location: "Toronto, ON",
    rating: 5,
    text: "Trademark Flare made registering my trademark with CIPO incredibly smooth. Their team guided me through every step, and I received my certificate in record time. Highly recommended for Canadian businesses!",
    business: "Thompson Consulting Inc."
  },
  {
    id: 2,
    name: "David MacDonald",
    location: "Vancouver, BC",
    rating: 5,
    text: "Professional, efficient, and affordable. The comprehensive search saved me from potential conflicts. The team's knowledge of CIPO procedures is outstanding.",
    business: "Pacific Tech Solutions"
  },
  {
    id: 3,
    name: "Sophie Tremblay",
    location: "Montreal, QC",
    rating: 5,
    text: "Excellent service! They handled both English and French requirements perfectly. The trademark monitoring gives me peace of mind. Worth every penny!",
    business: "Tremblay Cosmetics"
  },
  {
    id: 4,
    name: "Michael O'Brien",
    location: "Calgary, AB",
    rating: 5,
    text: "The Platinum package was perfect for my growing business. The comprehensive search report was detailed, and the cease & desist letter template has been invaluable.",
    business: "O'Brien Energy Group"
  },
  {
    id: 5,
    name: "Anika Patel",
    location: "Ottawa, ON",
    rating: 5,
    text: "Fast, reliable, and knowledgeable. Trademark Flare understood my needs and delivered exceptional results. The dedicated case manager made all the difference.",
    business: "Patel Digital Marketing"
  },
  {
    id: 6,
    name: "William Fraser",
    location: "Halifax, NS",
    rating: 5,
    text: "I've used their services for three different trademarks now. Consistent quality and great communication throughout. They truly understand Canadian trademark law and CIPO processes.",
    business: "Fraser Brewing Co."
  },
  {
    id: 7,
    name: "Jessica Chen",
    location: "Markham, ON",
    rating: 5,
    text: "I was worried about the complexity of CIPO filing, but Trademark Flare handled everything perfectly. Their expertise in Canadian trademark law is unmatched. Worth every penny!",
    business: "Chen Marketing Group"
  },
  {
    id: 8,
    name: "Robert Johnson",
    location: "Winnipeg, MB",
    rating: 5,
    text: "The team went above and beyond. They caught potential issues early and helped me adjust my application for maximum protection. True professionals!",
    business: "Johnson Coffee Co."
  },
  {
    id: 9,
    name: "Marie Dubois",
    location: "Quebec City, QC",
    rating: 5,
    text: "Fast, transparent, and extremely knowledgeable. They made the entire trademark registration process stress-free. I've already recommended them to other business owners!",
    business: "Dubois Fashion"
  },
  {
    id: 10,
    name: "Brandon Mitchell",
    location: "Edmonton, AB",
    rating: 5,
    text: "I tried filing on my own and got rejected. Trademark Flare fixed my application and got it approved. Should have used them from the start!",
    business: "Mitchell Sports Gear"
  },
  {
    id: 11,
    name: "Linda Wang",
    location: "Richmond, BC",
    rating: 5,
    text: "Outstanding service from consultation to final registration. Their 98% success rate is no accident - they really know what they're doing with CIPO applications!",
    business: "Wang Wellness Center"
  },
  {
    id: 12,
    name: "James Anderson",
    location: "London, ON",
    rating: 5,
    text: "Excellent communication throughout the process. They kept me updated at every stage and answered all my questions promptly. Highly professional team!",
    business: "Anderson Construction"
  }
];

export const processSteps = [
  {
    step: 1,
    title: "Consultation & Search",
    description: "We review your trademark application and conduct a comprehensive search through CIPO's database to ensure your mark is unique and registrable across Canada."
  },
  {
    step: 2,
    title: "Filing & Submission",
    description: "Our experts prepare and file your application with the Canadian Intellectual Property Office (CIPO), ensuring all documentation meets federal requirements."
  },
  {
    step: 3,
    title: "Monitoring & Protection",
    description: "We monitor your application status, respond to office actions, and secure your trademark registration, providing ongoing protection for your Canadian brand."
  }
];

export const formSubmission = (formData) => {
  // Mock form submission - will be replaced with actual API call
  console.log('Form submitted:', formData);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: 'Thank you! We will contact you shortly.' });
    }, 1000);
  });
};

export const services = [
  {
    id: 'trademark-registration',
    title: 'Trademark Registration (Canada)',
    shortDesc: 'Protect your brand across Canada with CIPO registration',
    icon: 'Shield',
    link: '/services/trademark-registration'
  },
  {
    id: 'copyright-registration',
    title: 'Copyright Registration',
    shortDesc: 'Secure your creative works and intellectual property',
    icon: 'FileText',
    link: '/services/copyright-registration'
  },
  {
    id: 'comprehensive-search',
    title: 'Trademark Comprehensive Search',
    shortDesc: 'Thorough CIPO database search before filing',
    icon: 'Search',
    link: '/services/comprehensive-search'
  },
  {
    id: 'company-formation',
    title: 'Company Formation',
    shortDesc: 'Incorporate your business in Canada with federal or provincial registration',
    icon: 'Building',
    link: '/services/company-formation'
  },
  {
    id: 'amazon-brand-registry',
    title: 'Amazon Brand Registry',
    shortDesc: 'Register your brand on Amazon with trademark support',
    icon: 'Package',
    link: '/services/amazon-brand-registry'
  }
];

export const pricingPlans = [
  {
    name: 'Basic',
    price: 'CAD $60',
    note: '+ CIPO Filing Fee',
    features: [
      'Case Review',
      'Basic Trademark Search',
      'Trademark Monitoring Services (1 Month)',
      'Trademark Secured®',
      'Filing along with your Paperwork',
      '100% Approval Guarantee'
    ],
    footnote: 'CIPO Filing Fee: $491 CAD per class',
    recommended: false,
    badge: null
  },
  {
    name: 'Standard',
    price: 'CAD $199',
    note: '+ CIPO Filing Fee',
    features: [
      'Case Review by a (TM Expert)',
      'Basic Free Trademark Search',
      'Trademark Monitoring Services (3 Months)',
      'Trademark Secured®',
      'Refusal Risk Meter®',
      'Filing along with your Paperwork',
      '100% Approval Guarantee'
    ],
    footnote: 'CIPO Filing Fee: $491 CAD per class',
    recommended: true,
    badge: 'Recommended'
  },
  {
    name: 'Deluxe',
    price: 'CAD $399',
    note: '+ CIPO Filing Fee',
    features: [
      'Case Review & Filing by an (Attorney)',
      'Expedited Application Processing within 24 Hours',
      'Filing along with Complete Paperwork',
      'Trademark Monitoring Services (12 Months)',
      'Trademark Secured®',
      'Refusal Risk Meter®',
      'Litigant Scan',
      'Comprehensive Trademark Search Report (all 10 provinces & 3 territories + social media/domain)',
      'Cease & Desist Letter',
      'Dedicated Account Manager',
      '100% Approval Guarantee'
    ],
    footnote: 'CIPO Filing Fee: $491 CAD per class',
    recommended: false,
    badge: 'Best Seller'
  }
];
